import React,{useEffect} from "react";
import 'react-awesome-slider/dist/styles.css';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ScreenResize from "../ScreenResize/ScreenResize";
import normatecaStore from "../../../stores/normatecaStore";
import { useNavigate } from "react-router-dom";

export default function DeInteres(){
    const imgurl = process.env.REACT_APP_IMG_URL + "normateca/secciones/deinteres/"; 
    const nasurl= process.env.REACT_APP_NAS + "D_interes/"
    const screen= ScreenResize();
    const navigate = useNavigate();
    const {setDeInteres,jsonDeInteres,setContenido} =
    normatecaStore((state) =>( { 
        setDeInteres: state.setDeInteres,
        jsonDeInteres: state.jsonDeInteres,
        setContenido: state.setContenido,
     })); 
     useEffect(() => {
        setDeInteres("home").catch(null);
      }, []);
      const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        autoplaySpeed:7000,
        slidesToShow: screen.width<500? 1 : screen.width < 1000? 2: screen.width < 1260? 3 : 4,
        slidesToScroll: screen.width<500 ? 1 : screen.width < 1000? 2: screen.width < 1260? 3 : 4,
        autoplay: true,
      }
      const cambiaContenido =(opcVis, indices,opcM)=>{
        setContenido(opcVis,indices,opcM).catch(null); 
        navigate("/app/normateca/masinfo");
     }
     const abrirURLArch=(url,archivo)=>{
        if(url!==""){window.open(url,'_blank');}
        if(archivo!==""){window.open(nasurl + archivo,'_blank');}
     }
    return(
        <div>
            <div className="divTit">
                <div className="titpublicRes">De interés</div>
                <div className="linepublicRes"></div>
            </div>
            <div className="divDeInte">
                <div className="divDeIntSha">

                <div className="divCarruselDI">
                    <Slider {...settings} >
                    {jsonDeInteres?.map((ia,index)=>(
                            index<=6?<div  key={"jd" + index.toString()} >
                                <div className="zoom padRight-05">
                                    <a onClick={()=>abrirURLArch(ia.url? ia.url:"",ia.archivo)} target="_blank" className="cursor-pointer">
                                        <img src={imgurl + ia.img} className="width-15-4DIrem" />
                                    </a>
                                </div>
                            </div>
                            : null
                        ))}
                    </Slider>
                </div>
                <div className="divVerMas">
                    {/* <Link to='/normateca/masinfo' target="_blank" > */}
                        {/* <button type="button" className="btnVerMas">Más información...<span className="inegi-nav-der"></span></button> */}
                        <button type="button" className="btnVerMas" onClick={()=>cambiaContenido("masInfo",0,"masInfo")}>Más información...<span className="inegi-nav-der"></span></button>

                    {/* </Link> */}
                </div>
              </div>
            </div>

        </div>
    )
}